import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen.ts';

/**
 * Router context shape — every route loader gets `{ queryClient }` so it can
 * call `queryClient.ensureQueryData(...)` for SSR-style hydration without us
 * needing to thread the client through props.
 */
export interface RouterContext {
  queryClient: QueryClient;
}

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0, // delegate caching to TanStack Query
    // Globe is the differentiator — keep prior screen visible during route
    // transitions so the user does not see flashes between drawer routes.
    defaultPendingMs: 200,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
